module.exports = __webpack_public_path__ + "static/survival_days-b416a43a6fbbe7eed127ea0439847388.jpg";